var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Tabs',{attrs:{"tabNames":_vm.tabNames,"tabId":'myTab'}}),_c('div',{staticClass:"tab-content",attrs:{"id":"myTabContent"}},[_c('WalletTab',{attrs:{"wallet":_vm.wallet,"refetch":_vm.refetch}}),_c('WalletCards'),_c('WalletSubscriptions')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }